import React from 'react';

const BarraInfoNosotros = () => {
  return (
    <section className="overflow-visible z-index-4 bg-transparent feature-box1">
      <div className="container-fluid px-xxl-15">
        <div
          className="rounded pt-7 pt-md-13 px-1-6 px-xl-2-9 overflow-visible position-relative bg-img cover-background dark-overlay"
          style={{ backgroundImage: `url('/assets/img/productos/pisos-vinilicos-lvt/piso-vinilico-background.jpg')` }}
        >
          <div className="row g-0 z-index-4 position-relative">
            <div className="col-xl-3 mb-1-9 mb-xl-0 wow fadeIn" data-wow-delay="200ms">
              <div className="title-style3 white mb-1-6 mb-xl-2-3">
                <h2 className="mb-0 h1 text-white">Acerca de nosotros</h2>
              </div>
              <a className="butn-style3 medium" href="#contacto">
                Contáctanos
              </a>
            </div>
            <div className="col-xl-9 why-us-inner position-relative z-index-4">
              <div className="row ps-xl-2-3 mt-n1-9">
                <div className="col-sm-6 col-lg-4 mt-1-9 wow fadeIn" data-wow-delay="400ms">
                  <div className="card border-0 text-center shadow h-100">
                    <div className="card-body px-1-6 px-sm-1-9 py-1-9 py-md-2-9">
                      <i className="ti-check-box display-13 text-secondary mb-4"></i>
                      <h3 className="h5 mb-3">
                        <a href="#entrega-inmediata">Entrega inmediata</a>
                      </h3>
                      <p className="mb-sm-1-9 text-color-light-blue">
                        Contamos con stock en bodega para surtir el mismo día.
                      </p>
                      <a href="#ubicacion" className="text-dark text-primary-hover font-weight-600">
                        Ver ubicación <i className="ti-arrow-right ms-2 align-middle display-30"></i>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-sm-6 col-lg-4 mt-1-9 wow fadeIn" data-wow-delay="600ms">
                  <div className="card border-0 text-center shadow h-100">
                    <div className="card-body px-1-6 px-sm-1-9 py-1-9 py-md-2-9">
                      <i className="ti-check-box display-13 text-secondary mb-4"></i>
                      <h3 className="h5 mb-3">
                        <a href="#cotizacion-asesoria">Cotización y asesoría</a>
                      </h3>
                      <p className="mb-sm-1-9 text-color-light-blue">
                        Te ayudamos a calcular tu proyecto y cotizamos el mismo día.
                      </p>
                      <a href="#contacto" className="text-dark text-primary-hover font-weight-600">
                        Contáctanos <i className="ti-arrow-right ms-2 align-middle display-30"></i>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-sm-6 col-lg-4 mt-1-9 wow fadeIn" data-wow-delay="800ms">
                  <div className="card border-0 text-center shadow h-100">
                    <div className="card-body px-1-6 px-sm-1-9 py-1-9 py-md-2-9">
                      <i className="ti-check-box display-13 text-secondary mb-4"></i>
                      <h3 className="h5 mb-3">
                        <a href="#garantia-calidad">Garantía de Calidad</a>
                      </h3>
                      <p className="mb-sm-1-9 text-color-light-blue">
                        Todos nuestros productos cuentan con garantía de calidad.
                      </p>
                      <a href="#contacto" className="text-dark text-primary-hover font-weight-600">
                        Contáctanos <i className="ti-arrow-right ms-2 align-middle display-30"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-inline-block p-2 rounded-circle bg-secondary position-absolute z-index-1 bottom-0 left-10 ani-top-bottom"></div>
    </section>
  );
};

export default BarraInfoNosotros;